import Button from '@mui/material/Button';

const CustomButton = ({ buttonName, icon: Icon, onClick, color }) => {
    return (
        <>
            <Button variant="contained" color={color} onClick={onClick} >
                {Icon && <Icon />}
                {buttonName}

            </Button>

        </>
    )
}

export default CustomButton;